
import './App.css';
import Day1 from './components/day-1/day-1';
import Day2 from './components/day-2/day-2';
import Day4 from './components/day-4/day-4';
import Day3 from './components/day-3/day-3';
import Day5 from './components/day-5/day-5';
import Day6 from './components/day-6/day-6';
import Day7 from './components/day-7/day-7';
import Day8 from './components/day-8/day-8';
import Day9 from './components/day-9/day-9';
import Day10 from './components/day-10/day-10';
import Day11 from './components/day-11/day-11';
import Day12 from './components/day-12/day-12';
import Day13 from './components/day-13/day-13';
import Day14 from './components/day-14/day-14';
import Day15 from './components/day-15/day-15';
function App() {
  return (
    <div className="App" >
      <Day1 />
      <Day2 />
      <Day3 />
      <Day4 />
      <Day5 />
      <Day6 />
      <Day7 />
      <Day8 />
      <Day9 />
      <Day10 />
      <Day11 />
      <Day12 />
      <Day13 />
      <Day14 /> 
      <Day15 />   
    </div>
  );
}

export default App;
